import {useEffect} from 'react';

import {useImageSelection} from '@dms/shared';

interface UseVehicleAlbumImageSelectionProps {
  /**
   * Called whenever the image selection changes.
   * Must be a stable reference (e.g. wrapped in useCallback) to avoid
   * re-triggering this effect on every render.
   */
  onSelectionChange?: (selectedImages: string[]) => void;
}

export function useVehicleAlbumImageSelection({
  onSelectionChange,
}: UseVehicleAlbumImageSelectionProps = {}) {
  const selection = useImageSelection();
  const {selectedImageIds} = selection;

  useEffect(
    function notifyAlbumImageSelectionChange() {
      onSelectionChange?.(Array.from(selectedImageIds));
    },
    [selectedImageIds, onSelectionChange]
  );

  return selection;
}
